<script lang="ts" setup>
  import { SentryLib } from '@/app/plugins/sentry/sentry'

  const isProduction = import.meta.env.MODE !== 'development'
  if (isProduction) {
    SentryLib.pushError(`[NOT FOUND URL] route: ${window.location.href}`)
  }

  window.location.href = `${window.location.origin}/404`
</script>
